module.exports = __webpack_public_path__ + "img/trumpx_trump.xpx.632e886.png";